import { useEffect, useState } from "react";

export function useTypeWritter(work: string[]) {
    const [word, setWord] = useState<null | string>(null);  //当前显示
    const [eventQueue, setEventQueue] = useState<string[]>(work[0].split(''));
    const [nextQueue, setNextQueue] = useState<string[]>([]);

    const [dataIndex, setDataIndex] = useState<number>(0);  //当前索引
    const [index, setIndex] = useState<number>(0);  //当前索引

    const [loop, setLoop] = useState<number>(1)

    const [timeInterval, setTimeInterval] = useState<number>(20)

    useEffect(() => {
        const currentinterval = setTimeout(() => {
            if (timeInterval == 1000) {
                setTimeInterval(20);
            }


            if (loop == 1) { 
                const b: string[] = [...nextQueue];
                b.push(eventQueue[index]);
                setNextQueue(b);
                setWord(b.join(''));
                const i = index + 1
                setIndex(i);
                if (i == eventQueue.length - 1) {
                    setLoop(2);
                    setTimeInterval(1000)
                }
            } else if (loop == 2) { 
                const b: string[] = [...nextQueue];
                b.pop();
                setNextQueue(b);
                setWord(b.join(''));

                if (index <= 1) {
                    setLoop(1);
                    const datai = dataIndex + 1;
                    if (datai == work.length) {
                        setDataIndex(0);
                        setEventQueue(work[0].split(''))
                    } else {
                        setDataIndex(datai);
                        setEventQueue(work[datai].split(''))
                    }

                }
                const i = index - 1
                setIndex(i);
            }

        }, timeInterval)

        return function clear() {
            clearTimeout(currentinterval)
        }
    }, [index])


    return word
}